import React, { useState } from "react";
import { Select, Functions } from "rhombus-react";
import { TEMPERATURE_OPTIONS } from "utils/constants";

import AdvertiserObjective from "./AdvertiserObjective";

const TEMPERATURE_DESCRIPTION = "Temperature controls the randomness of the selection. High temperature leads to more exploration, while low temperature leads to more exploitation of the best-performing variants.";

export default function SoftmaxSelection(props){
	const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);

	let {
		onObjective,
		selectedObjective,
		temperature,
		onTemperatureChange,
		showValidation,
	} = props;

	const handleAdvancedOptionsClick = () => {
		setShowAdvancedOptions(!showAdvancedOptions);
	};

	return (
		<div className="radio-options softmax-optimization-options">
			<div className="selector-list">
				<AdvertiserObjective
					onObjective={onObjective}
					selectedObjective={selectedObjective}
					required={showValidation}
					meta={showValidation ? { valid: !!selectedObjective, dirty: true } : undefined}
				/>
			</div>

			<div className="advanced-options-container">
				<button
					type="button"
					className={`advanced-options-button ${showAdvancedOptions ? 'expanded' : ''}`}
					onClick={handleAdvancedOptionsClick}
				>
					<span className="advanced-options-arrow">{showAdvancedOptions ? '▼' : '►'}</span>
					<span className="advanced-options-text">Advanced Options</span>
				</button>
			</div>

			{showAdvancedOptions && (
				<div className="input-with-tooltip">
					<Select
						label="Temperature"
						placeholder="Select Temperature"
						tip={{
							description: TEMPERATURE_DESCRIPTION,
							direction: 'top',
							size: 'large',
						}}
						options={TEMPERATURE_OPTIONS}
						onChange={val => onTemperatureChange(val.value)}
						value={TEMPERATURE_OPTIONS.find(opt => opt.value === temperature)}
						isClearable={false}
						onMenuScrollToBottom={Functions.noop}
					/>
				</div>
			)}
		</div>
	);
}

